import api from "../../index";

export const GetAllRulesApi = (params) => api.get(`rulemaster/getallrule?${params}`);
export const GetrulesByIdApi = (traderId) => api.get(`rulemaster/getrulebyid/${traderId}`);
export const UpdateRulesApi = (data) => api.post('rulemaster/ruleedit', data);
export const UpdateUserStatusApi = (data) => api.patch('RuleMaster/SetDefaultRule', data);
export const addRulesApi = (data) => api.post('RuleMaster/Create-Rule', data);

